import CartSummaryDetails from './cartSummaryDetails';

export default CartSummaryDetails;